import { Stack, Text, DirectionalHint } from "@fluentui/react";
import { stringUtils, useTheme, TooltipHost } from "cayo.ui";
import React, { FC, useMemo } from "react";
import styled from "styled-components";
import { Severity } from "@cayo/shared/api/types/cayo-graph";
import { commonMessages } from "@cayo/shared/messages/common";
import { useIntl } from "react-intl";

const SeverityBadge: FC<{ value: Severity; text?: string }> = ({ value, text }) => {
  const { getColor } = useTheme();
  const intl = useIntl();

  const iconColors = useMemo(() => {
    if (value !== "debug" && value !== "informational" && value !== undefined) {
      return {
        backgroundColor: getColor(value, "Severity"),
        color: value === "medium" || value === "warning" ? "black" : "white",
      } as Partial<React.CSSProperties>;
    }

    return undefined;
  }, [value]);

  return (
    <Stack horizontal={true} verticalAlign="center" tokens={{ childrenGap: 0 }}>
      <TooltipHost
        directionalHint={DirectionalHint.topAutoEdge}
        tooltip={intl.formatMessage(commonMessages.severity)}
        showCopyButton={false}
      >
        <BadgeText
          variant="smallPlus"
          color={iconColors?.color}
          backgroundColor={iconColors?.backgroundColor}
        >
          {text ?? stringUtils.toSpaceDelimitedPascalCase(value)}
        </BadgeText>
      </TooltipHost>
    </Stack>
  );
};

const BadgeText = styled(Text)<{ color?: string; backgroundColor?: string }>`
  text-align: center;
  font-weight: 500;
  min-width: 64px;
  position: relative;
  left: -1px;
  padding: 2px 4px;
  color: ${(props) => props.color};
  background: ${(props) => props.backgroundColor};
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  text-transform: uppercase;
`;

export default SeverityBadge;
